/* Statement reveal — line one dims and line two rises in as the pinned block scrolls. */
if (!customElements.get('statement-reveal')) {
  customElements.define('statement-reveal', class extends HTMLElement {
    connectedCallback() {
      if (document.documentElement.classList.contains('reduced-motion')) return;
      this.one = this.querySelector('[data-line-one]');
      this.two = this.querySelector('[data-line-two]');
      this.p = 0;
      const clamp = x => Math.min(1, Math.max(0, x)), ease = x => x * x * (3 - 2 * x);
      const tick = () => {
        const r = this.getBoundingClientRect();
        const target = clamp(-r.top / Math.max(1, r.height - innerHeight));
        this.p += (target - this.p) * 0.12;
        const k = ease(clamp((this.p - 0.1) / 0.35));
        this.one.classList.toggle('is-dim', k > 0.5);
        this.two.style.opacity = k.toFixed(3);
        this.two.style.transform = `translate3d(0,${((1 - k) * 24).toFixed(1)}px,0)`;
        this.raf = Math.abs(target - this.p) > 0.0005 || this.visible ? requestAnimationFrame(tick) : 0;
      };
      this.io = new IntersectionObserver(([e]) => {
        this.visible = e.isIntersecting;
        if (this.visible && !this.raf) this.raf = requestAnimationFrame(tick);
      });
      this.io.observe(this);
    }
    disconnectedCallback() { this.io?.disconnect(); cancelAnimationFrame(this.raf); }
  });
}
